import { Link } from "react-router-dom";
import { GraduationCap, ArrowUpRight } from "lucide-react";
import { Reveal, RevealLine } from "../lib/motion";
import { ACADEMY_PROGRAMS } from "../academyData";

export const Academy = () => (
  <section id="academy" data-testid="academy-section" className="py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-6 sm:px-12">
      <div className="max-w-2xl mb-16">
        <div className="overline mb-6">Academy · Executive Programs</div>
        <h2 className="font-serif text-4xl sm:text-5xl leading-tight text-[var(--ink)]">
          <RevealLine>Formazione executive</RevealLine>
          <RevealLine delay={0.08} className="italic text-[var(--petrol)]">che cambia le regole.</RevealLine>
        </h2>
        <Reveal delay={0.15}><p className="mt-6 text-lg text-[var(--ink-soft)]">Percorsi intensivi per leader e board member che vogliono padroneggiare AI, rischio e trasformazione digitale. Costruiti sul metodo <span className="italic">The Executive Lab Method™</span>.</p></Reveal>
      </div>

      <div className="grid md:grid-cols-2 gap-px bg-[var(--line)] border border-[var(--line)]">
        {ACADEMY_PROGRAMS.map((c, i) => (
          <Reveal key={c.slug} delay={i * 0.08} className="bg-white">
            <Link to={`/academy/${c.slug}`} data-testid={`academy-card-${c.slug}`}
              className="group block p-8 sm:p-10 h-full hover:bg-[var(--paper-2)] transition-[background-color] duration-500">
              <div className="flex items-center justify-between mb-6">
                <GraduationCap size={26} strokeWidth={1.25} className="text-[var(--petrol)]" />
                <span className="overline !text-[var(--anthracite)]">{c.weeks} · {c.sessions.split(" · ")[0]}</span>
              </div>
              <div className="text-xs uppercase tracking-[0.15em] text-[var(--accent)] mb-2">{c.level}</div>
              <span className="inline-flex items-center gap-2 text-[0.65rem] uppercase tracking-[0.15em] text-[var(--accent)] border border-[var(--gold)]/50 px-2.5 py-1 mb-4" data-testid={`academy-badge-${c.slug}`}>
                <span className="w-1.5 h-1.5 rounded-full bg-[var(--gold)] animate-pulse" /> {c.cohortStatus}
              </span>
              <h3 className="font-serif text-2xl sm:text-3xl text-[var(--ink)] mb-3 flex items-start gap-2">
                {c.title}
                <ArrowUpRight size={18} strokeWidth={1.5} className="mt-1 shrink-0 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-[opacity,transform] duration-400 text-[var(--accent)]" />
              </h3>
              <p className="text-[var(--ink-soft)] leading-relaxed">{c.tagline}</p>
              <span className="mt-6 inline-block text-xs font-semibold uppercase tracking-[0.15em] text-[var(--petrol)] link-underline">Scopri il programma</span>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
